// extracted by mini-css-extract-plugin
export default {"formContainer":"UserEditForm_formContainer__gwgdR"};